import React from "react";
import { useTranslation } from "react-i18next";
import { PlansList } from "@features/Plans/PlansList";
import { PaperAndPencilIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { useOverviewQuery } from "@services/overview/queries";

interface ISelectPlanModalProps extends IUseModalProps {
  jointBillServiceId: number;
}

export const SelectPlanModal: React.FC<ISelectPlanModalProps> = (props) => {
  const { jointBillServiceId, ...rest } = props;
  const modal = useModal(rest);
  const { t } = useTranslation();

  const { data: overviewData } = useOverviewQuery();

  const selectedJointBillServiceDisplayName =
    overviewData?.jointBillServices.find(
      (jointBillService) =>
        jointBillService.jointBillServiceId === jointBillServiceId,
    )?.displayName ?? t("common.defaultAddress");

  return (
    <Modal
      modal={modal}
      title={t("plan.modal.selectPlan.title")}
      subtitle={
        <React.Fragment>
          {t("plan.modal.selectPlan.subtitle")}{" "}
          <span className="text-base-black">
            {selectedJointBillServiceDisplayName}
          </span>
        </React.Fragment>
      }
      className="min-w-full lg:w-full xl:min-w-[72rem]"
      badgeProps={{ icon: PaperAndPencilIcon }}
    >
      <div>
        <PlansList
          jointBillServiceId={jointBillServiceId}
          onSuccess={() => modal.close()}
        />
      </div>
    </Modal>
  );
};
